import React from 'react';

function StackChart() {
  return <div>StackChart</div>;
}

export default StackChart;
